import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";
import App from './App';
import './bootstrap/bootstrap.scss';
import './index.scss';
import { store } from './store';
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').then(registration => {
      console.log('SW registered: ', registration);

      // Listen for updates to the service worker
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // New update available
              console.log('New content is available; please refresh.');
            } else {
              // Content cached for offline use
              console.log('Content is cached for offline use.');
            }
          }
        };
      };
    }).catch(registrationError => {
      console.log('SW registration failed: ', registrationError);
    });
  });
}

if (process.env.NODE_ENV === 'production') {
  const firebaseConfig = {
    apiKey: "AIzaSyB0kP-6DSkCJ3Hf43-vTWeYwC0241GgnZA",
    authDomain: "kangury-pwa.firebaseapp.com",
    projectId: "kangury-pwa",
    storageBucket: "kangury-pwa.firebasestorage.app",
    messagingSenderId: "35378784537",
    appId: "1:35378784537:web:ececd6fc3f6ca610a8bd88",
    measurementId: "G-SMEQD887PG"
  };

  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  const analytics = getAnalytics(app);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
